
<template>
  <div class="appDashboard dashboard1">
    <div :class="{container:appConfig.container}">
      <!-- <app-header :title="title"></app-header> -->
      <app-header :title="AppName"></app-header>
    </div>
    <v-layout class="flex md12 ml-1" :class="{container:appConfig.container}" row wrap>
      <app-card class="xs12 md12 d-flex" :obj="{title}">
        <div slot="body">
          <v-layout row wrap class="ml-3">
            <template>
              <v-flex xs12 offset-md3 md6 mt-2 mb-2 v-for="system in systems" :key="system.systemSn">
                <v-btn block color="primary" v-on:click="onClickSystem(system.systemSn, system.systemNm)">
                  <span>{{system.systemNm}}</span>
                </v-btn>
              </v-flex>
            </template>
          </v-layout>
        </div>
      </app-card>
    </v-layout>
  </div>
</template>

<script>
import echarts from "echarts";
import mediator from "../../components/common/mediator.vue";
import moment from "moment";

export default {
  name: "TopPage",
  mixins: [mediator],
  mounted() {
    this.$root.currentPageName = 'BMIoT-SUN';

    this.updateView();
  },
  data() {
    const $t = this.$t.bind(this);

    return {
      systems: [],
      error: false,
      AppName: "BMIoT-SUN",
      title: $t("TopPage.Item"),
    };
  },
  methods: {
    onClickSystem(systemSn, systemNm) {
      const $t = this.$t.bind(this);
      this.$root.currentSerial.system = systemSn;
      this.$root.currentPageName = $t("Header.SystemName") + ': ' + systemNm;
      this.$router.push({ name: "bank_status" });
    },    
    setWaitTime() {
      let vm = this;
      if(vm.svgWaitingTime) return;
      
      vm.axios
        .get(`${vm.$root.url}/TopPage/WaitTime`, {
          headers: {
            Authorization: `Bearer ${vm.$root.token}`
          }
        })
        .then(response => {
          vm.svgWaitingTime = response.data.waitTime;
        })
        .catch(error => {
          vm.error = true;
          vm.result = "Error";
        });
    },
    updateView() {
      let vm = this;
      vm.axios
        .get(`${vm.$root.url}/TopPage/SystemList`, {
          headers: {
            Authorization: `Bearer ${vm.$root.token}`
          },
          params: {
            type: vm.$root.type,
            assign: vm.$root.assign
          }
        })
        .then(response => {
          vm.systems = response.data;
        })
        .catch(error => {
          vm.error = true;
          vm.result = "Error";
        });
    }
  }
};
</script>

<style>
  .dashboard1 .offset-sm3 {
    margin: 0 !important;
    flex-basis: 100% !important;
    max-width: 100% !important;
  }
</style>




// WEBPACK FOOTER //
// src/router/Customer/TopPage.vue